<template>
  <v-container fluid grid-list-xl>
    <app-diagnostico
      titulo="Avaliação da equipe (Competências Comportamentais)"
      :inicio="diagnostico.inicioComportamental"
      :fim="diagnostico.fimComportamental"
    >
      <template v-slot:body>
        <!-- Não há comportamentos consolidados para avaliar -->
        <v-col v-if="semComportamentos">
          <app-alert
            type="warning"
            icon="warning"
            message="Não há comportamentos disponíveis para realizar a avaliação."
          />
        </v-col>

        <!-- Usuário complementar tenta avaliar pares (só usuário do tipo REGULAR podem avaliar pares) -->
        <v-col v-else-if="tipo == 'PARES' && usuarioMapeamento.tipo == 'COMPLEMENTAR'">
          <info-dispensa mensagem="Usuário não realiza avaliação da equipe." />
        </v-col>

        <!-- Todos da equipe estão dispensados -->
        <v-col v-else-if="avaliacoes.length === 0">
          <info-dispensa
            :dispensas="dispensasEquipe"
            mensagem="Não é possível realizar a avaliação da sua equipe."
          />
        </v-col>

        <!-- Avaliação -->
        <v-col v-else centered cols="12">
          <!-- Abas -->
          <v-tabs
            v-model="categoria"
            color="secondary"
            centered
            icons-and-text
          >
            <v-tabs-slider color="secondary" />

            <!-- Geração das abas -->
            <v-tab
              v-for="i in categorias.length"
              :key="i"
              :href="'#' + categorias[i - 1].id"
              class="mt-3"
            >
              <span class="grey--text text--darken-2">{{ categorias[i - 1].descricao }}</span>
              <v-badge
                :color="categorias[i - 1].id === categoria ? 'secondary' : 'grey'"
                :content="categorias[i - 1].quantidade === 0 ? '0' : categorias[i - 1].quantidade"
              >
                <v-icon :color="categorias[i - 1].id === categoria ? 'secondary' : 'grey'">
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-badge>
            </v-tab>

            <!-- Componentes -->
            <v-tabs-items v-model="categoria">
              <!-- Componente da aba de avaliação -->
              <v-tab-item value="equipe">
                <avaliacao
                  titulo="AVALIAÇÃO DA EQUIPE"
                  :diagnostico="diagnostico"
                  :tipo="tipo"
                  :perspectiva="perspectiva"
                  :inicio="diagnostico.inicioComportamental"
                  :fim="diagnostico.fimComportamental"
                  :tutorial="tutorial"
                />
              </v-tab-item>

              <!-- Componente da aba com os participantes dispensados -->
              <v-tab-item
                v-if="dispensasEquipe.length > 0"
                value="dispensas"
              >
                <info-dispensa :dispensas="dispensasEquipe" />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </template>
    </app-diagnostico>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDiagnostico from '@/components/core/AppDiagnostico';
import AppAlert from '@/components/core/AppAlert';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import Avaliacao from '@/components/diagnostico/Avaliacao';

export default {
  name: 'AvaliacaoDeServidoresComportamento',

  components: {
    AppDiagnostico,
    AppAlert,
    InfoDispensa,
    Avaliacao,
  },

  data() {
    return {
      categoria: '',
      tipo: '',
      perspectiva: 'COMPORTAMENTAL',
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      isDispensado: (state) => state.diagnostico.dispensado,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    avaliacoes() {
      if (this.tipo === 'SUBORDINADO') {
        return this.$store.state.diagnostico.subordinadoComportamental;
      }
      if (this.tipo === 'PARES') {
        return this.$store.state.diagnostico.paresComportamental;
      }
      return [];
    },
    dispensasEquipe() {
      return this.$store.state.diagnostico.dispensasEquipe.filter((d) => d.diagnostico.id === this.diagnostico.id);
    },
    tutorial() {
      let nome = '';
      if (this.tipo === 'SUBORDINADO') {
        nome = 'AvaliacaoEquipe';
      }
      if (this.tipo === 'PARES') {
        nome = 'AvaliacaoPares';
      }
      return { nome };
    },
    semComportamentos() {
      return this.$store.state.diagnostico.comportamentos.length === 0;
    },
    categorias() {
      const categorias = [];

      if (this.avaliacoes.length > 0) {
        categorias.push({
          id: 'equipe',
          descricao: 'Equipe',
          icone: 'groups',
          quantidade: this.avaliacoes.length,
        });
      }
      if (this.dispensasEquipe.length > 0) {
        categorias.push({
          id: 'dispensas',
          descricao: 'Dispensas',
          icone: 'hail',
          quantidade: this.dispensasEquipe.length,
        });
      }
      return categorias;
    },
  },

  watch: {
    categorias(value) {
      if (value.length > 0) {
        this.categoria = value[0].id;
      }
    },
  },

  created() {
    if (this.$route.name === 'AvaliacaoServidoresComportamento') {
      this.tipo = 'SUBORDINADO';
    } else if (this.$route.name === 'AvaliacaoParesComportamento') {
      this.tipo = 'PARES';
    }
  },
};
</script>
